export enum VisualCategoryEnum {
    PcNotebooks = 1,
    PcDesktop = 2,
    Print = 3,
    Supplies=4
}